import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { SkillShort } from '~/shared/data-contract/skill';
import type { LanguageCode } from '~/shared/internationalization';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

type UseSkillsSearchOptions = {
    readonly acceptLanguage: LanguageCode;
    readonly enabled?: boolean;
    readonly searchTerm: string;
};

export const useSkillsSearch = ({
    acceptLanguage,
    searchTerm,
}: UseSkillsSearchOptions): UseQueryResult<readonly SkillShort[], Error> => {
    const { fetchSkillsBySearchTerm } = useApplicationFetchers();

    return useQuery({
        enabled: searchTerm.trim().length >= 1,
        queryFn: async () => {
            const result = await fetchSkillsBySearchTerm({
                acceptLanguage,
                searchTerm: searchTerm.trim(),
            });

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: jobArchitectureKeys.skillsBySearchTerm(searchTerm.trim(), acceptLanguage),
        throwOnError: false,
    });
};
